<script setup lang="ts">
import { useTrackingStore } from '@dh-io-owpi/shared/src/stores/tracking';
import {
  useSectionsStore,
  defaultSections,
  sectionAnchorMap,
  sectionTrackLabelMap,
  type SectionName,
} from '@dh-io-owpi/spa/src/stores/sections';

import { computed } from 'vue';

defineProps<{
  isDark: boolean;
}>();

const sectionsStore = useSectionsStore();
const { track } = useTrackingStore();

// Filtering out the undefined names & stage section from the list
const sectionsNames = computed(() => {
  return defaultSections.filter((name) => sectionsStore.visible[name] && sectionAnchorMap[name] && name !== 'stage');
});

function scrollTo(name: SectionName) {
  // Scroll to the specified section after a short delay to allow the sections to load and the flyout to close
  setTimeout(() => sectionsStore.scrollIntoView(name), 300);
}

const trackSubnavigationItem = (name: SectionName) => {
  track({
    timeout: 2000,
    category: 'link',
    action: 'vertical-navigation',
    label: sectionTrackLabelMap[name],
  });
};
</script>
<template>
  <wb-subnavigation-fly-in-item
    v-for="name in sectionsNames"
    :key="name"
    :active="sectionsStore.active === name"
    :theme="isDark ? 'dark' : 'light'"
  >
    <a
      :href="`#${sectionAnchorMap[name]}`"
      @click.prevent="
        scrollTo(name);
        trackSubnavigationItem(name);
      "
      @auxclick="trackSubnavigationItem(name)"
    >
      {{ $t(`${name}.subline`) }}</a
    >
  </wb-subnavigation-fly-in-item>
</template>
